import axios from 'axios'
import getSymbolFromCurrency from 'currency-symbol-map'
var accounting = require('accounting')

const initial = {
  config() {
    return {
      URL: {
        API: {
          host: '',
        },
      },
      flatpickrConfig: {
        dateFormat: 'd/m/Y',
        static: true,
      },
      dateTimeFormats: {
        vmask: '##/##/#### ##:##',
        display: 'DD/MM/YYYY HH:mm:ss',
        api: 'YYYY-MM-DD HH:mm:ss',
      },
      dateFormats: {
        vmask: '##/##/####',
        display: 'DD/MM/YYYY',
        api: 'YYYY-MM-DD',
      },
      speedUnits: [
        { unit: 'kilometers', short: 'km', perHour: 'km/h' },
        { unit: 'miles', short: 'mi', perHour: 'mph' },
      ],
      endpoints: {
        contact: 'contacts',
        customer: 'customers',
        supplier: 'suppliers',
      },
      theme: 'dark',
      mobileMenuOpen: false,
      screenBreakpoints: {
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
      },
      // from API:
      fuelTypes: [],
      productTypes: [],
      reminderMethods: [],
      financialAccounts: [],
      currency: '',
      currencySymbol: '',
      defaultSpeedUnit: '',
      defaultTaxPercentage: '',
      defaultReminderMethod: '',
      mailDriver: '',
      mailHost: '',
      mailPort: '',
      mailUsername: '',
      mailPassword: '',
      mailEncryption: '',
      mailFromAddress: '',
      mailFromName: '',
      companyName: '',
      companyAddress: '',
      companyPostCode: '',
      companyCity: '',
      companyState: '',
      companyCountry: '',
      companyPhone: '',
      companyIBAN: '',
      companyAccountNumber: '',
      logoPath: '',
      logoSmallPath: '',
      logoPrintPath: '',
      faviconPath: '',
      smsProvider: '',
    }
  },
  status() {
    return ''
  }
}

const state = {
  config: initial.config(),
  status: initial.status(),
}

const mutations = {
  SET(state, setting) {
    state.config[setting.identifier] = setting.value
  },
  SET_STATUS(state, status) {
    state.status = status
  },
  ERROR(state) {
    state.config = initial.config()
    state.status = 'error'
  },
  OPEN_SETTINGS_ERROR(state) {
    state.config = initial.config()
    state.status = 'open-settings-error'
  },
}

const actions = {
  setComplete({ commit }) {
    commit('SET_STATUS', 'complete')
  },
  setIncomplete({ commit }) {
    commit('SET_STATUS', 'incomplete')
  },
  get({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('settings')
        .then((response) => {
          for (let i in response.data) {
            // set accounting currency
            if (response.data[i].identifier === 'currency') {
              accounting.settings.currency.symbol = getSymbolFromCurrency(response.data[i].value)
              commit('SET', { identifier: 'currencySymbol', value: accounting.settings.currency.symbol })
            }
            commit('SET', response.data[i])
          }

          resolve(response.data)
        })
        .catch(err => {
          commit('ERROR')
          reject(err)
        })
    })
  },
  getOpen({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('settings/open')
        .then((response) => {
          for (let i in response.data) {
            commit('SET', response.data[i])
          }
          resolve(response.data)
        })
        .catch(err => {
          commit('OPEN_SETTINGS_ERROR')
          reject(err)
        })
    })
  },
  getFuelTypes({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('vehicles/fuel-types')
        .then((response) => {
          commit('SET', {identifier: 'fuelTypes', value: response.data})
          resolve(response.data)
        })
        .catch(err => {
          commit('ERROR')
          reject(err)
        })
    })
  },
  getProductTypes({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('products/types')
        .then((response) => {
          commit('SET', {identifier: 'productTypes', value: response.data})
          resolve(response.data)
        })
        .catch(err => {
          commit('ERROR')
          reject(err)
        })
    })
  },
  getReminderMethods({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('reminders/methods')
        .then((response) => {
          commit('SET', {identifier: 'reminderMethods', value: response.data})
          resolve(response.data)
        })
        .catch(err => {
          commit('ERROR')
          reject(err)
        })
    })
  },
  getFinancialAccounts({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('financial-accounts', {params: {
        noPagination: true,
      }})
        .then((response) => {
          commit('SET', {identifier: 'financialAccounts', value: response.data})
          resolve(response.data)
        })
        .catch(err => {
          commit('ERROR')
          reject(err)
        })
    })
  },
  changeTheme({ commit }, theme) {
    return new Promise((resolve) => {
      localStorage.setItem('theme', theme)
      commit('SET', { identifier: 'theme', value: theme })
      resolve()
    })
  },
  setAPIURL({ state }, url) {
    return new Promise((resolve) => {
      state.config.URL.API.host = url
      resolve()
    })
  },
  toggleMobileMenu({ state }) {
    return new Promise((resolve) => {
      state.config.mobileMenuOpen = !state.config.mobileMenuOpen
      if (state.config.mobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'visible'
      }
      resolve()
    })
  },
  setMobileMenu({ state }, val) {
    return new Promise((resolve) => {
      state.config.mobileMenuOpen = !!val
      if (state.config.mobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'visible'
      }
      resolve()
    })
  },
}

const getters = {
  config: state => state.config,
  status: state => state.status,
  defaultCashAccount: state => state.config.financialAccounts.filter(a => a.type === 'cash' && a.is_default)[0],
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
